(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.getElementById('CartDrawer');

    if (!drawer || drawer.dataset.markaCartReady === 'true') return;

    drawer.dataset.markaCartReady = 'true';

    const shopRoot = window.Shopify?.routes?.root || '/';
    const timerKey = 'markaCartReservationEnd';
    const timerDuration = 10 * 60 * 1000;

    let timerInterval;
    let refreshTimeout;

    const money = (cents, currency) => new Intl.NumberFormat(
      document.documentElement.lang || 'nl-NL',
      {
        style: 'currency',
        currency
      }
    ).format(cents / 100);
const moneyRoundedDown = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
style: 'currency',
currency,
minimumFractionDigits: 0,
maximumFractionDigits: 0
}).format(Math.floor(cents / 100));
    const fetchCart = async () => {
      const response = await fetch(`${shopRoot}cart.js`, {
        headers: {
          Accept: 'application/json'
        }
      });

      return response.json();
    };

    const startTimer = itemCount => {
      const box = drawer.querySelector('[data-cart-reservation]');
      const output = drawer.querySelector('[data-cart-reservation-time]');

      window.clearInterval(timerInterval);

      if (!box || !output || itemCount === 0) {
        sessionStorage.removeItem(timerKey);

        if (box) {
          box.hidden = true;
        }

        return;
      }

      box.hidden = false;

      let endTime = Number(sessionStorage.getItem(timerKey));

if (!endTime || endTime <= Date.now()) {        endTime = Date.now() + timerDuration;
        sessionStorage.setItem(timerKey, String(endTime));
      }

      const tick = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);

        output.textContent =
          `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        if (remaining === 0) {
          window.clearInterval(timerInterval);
        }
      };

      tick();
      timerInterval = window.setInterval(tick, 1000);
    };

    const updateShipping = cart => {
      const shipping = drawer.querySelector('[data-cart-shipping]');
      const message = drawer.querySelector('[data-cart-shipping-message]');
      const progress = drawer.querySelector('[data-cart-shipping-progress]');
      const threshold = Number(
        drawer.dataset.freeShippingThreshold || 9900
      );

      if (
        !shipping ||
        !message ||
        !progress ||
        cart.item_count === 0
      ) {
        if (shipping) {
          shipping.hidden = true;
        }

        return;
      }

      shipping.hidden = false;

      const remaining = Math.max(
        0,
        threshold - cart.total_price
      );

      const percentage = Math.min(
        100,
        cart.total_price / threshold * 100
      );

      progress.style.width = `${percentage}%`;

      message.textContent = remaining === 0
        ? drawer.dataset.freeShippingUnlocked
        : drawer.dataset.freeShippingRemaining.replace(
          '__AMOUNT__',
          money(remaining, cart.currency)
        );
    };

const updateTotals = cart => {
  const original = drawer.querySelector('[data-cart-original-total]');
  const finalTotal = drawer.querySelector('[data-cart-final-total]');
  const badge = drawer.querySelector('[data-cart-discount-badge]');

  const regularPrices = new Map(
    [...drawer.querySelectorAll('.cart__item[data-key][data-regular-unit-price]')]
      .map(item => [
        item.dataset.key,
        Number(item.dataset.regularUnitPrice)
      ])
  );

  const referenceTotal = cart.items.reduce((total, item) => {
    const regularPrice =
      regularPrices.get(item.key) || item.original_price;

    return total +
      Math.max(regularPrice, item.original_price) * item.quantity;
  }, 0);

  const savings = Math.max(
    0,
    referenceTotal - cart.total_price
  );

  const hasDiscount = savings > 0;

  drawer.dataset.cartCount = String(cart.item_count);

  if (original) {
    original.textContent = money(
      referenceTotal,
      cart.currency
    );

    original.hidden = !hasDiscount;
  }

  if (finalTotal) {
    finalTotal.textContent = money(
      cart.total_price,
      cart.currency
    );
  }

  if (badge) {
    badge.textContent =
      `${drawer.dataset.saveLabel.toUpperCase()} ${moneyRoundedDown(savings, cart.currency)}`;

    badge.hidden = !hasDiscount;
  }

  startTimer(cart.item_count);
  updateShipping(cart);
};

    const loadRecommendations = async cart => {
      const slot = drawer.querySelector(
        '[data-cart-recommendations]'
      );

      if (
        !slot ||
        !cart.items.length ||
        !drawer.dataset.recommendationsUrl
      ) {
        if (slot) {
          slot.innerHTML = '';
        }

        return;
      }

      const url = new URL(
        drawer.dataset.recommendationsUrl,
        window.location.origin
      );

      url.searchParams.set(
        'section_id',
        'cart-recommendations'
      );

      url.searchParams.set(
        'product_id',
        String(cart.items[0].product_id)
      );

      url.searchParams.set('limit', '4');
      url.searchParams.set('intent', 'related');

      const response = await fetch(url.toString());

      if (!response.ok) return;

      const html = await response.text();

      const documentFragment = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const content = documentFragment.querySelector(
        '[data-cart-recommendations-content]'
      );

      slot.innerHTML = content
        ? content.innerHTML
        : '';
    };

    document.addEventListener('cart:updated', event => {
      if (event.detail?.cart) {
        updateTotals(event.detail.cart);
        loadRecommendations(event.detail.cart);
        return;
      }

      window.clearTimeout(refreshTimeout);

      refreshTimeout = window.setTimeout(async () => {
        const cart = await fetchCart();

        updateTotals(cart);
        loadRecommendations(cart);
      }, 80);
    });

    [
      'ajaxProduct:added',
      'cart:itemadded'
    ].forEach(eventName => {
      document.addEventListener(eventName, async () => {
        const cart = await fetchCart();

        updateTotals(cart);
        loadRecommendations(cart);
      });
    });

    fetchCart().then(cart => {
      updateTotals(cart);
      loadRecommendations(cart);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
